export enum OrderAttachmentCategory {
    OrderConfirmation = 'order-confirmation',
    OrderProformaInvoice = 'order-proforma-invoice',
}

export enum NotificationAction {
    Read = 'read',
    Unread = 'unread',
}

export enum NotificationActionType {
    OrderConfirmed = 'OrderConfirmed',
    OrderInvoice = 'OrderInvoice',
    OrderReady = 'OrderReady',
    ServiceCallEvidenced = 'ServiceCallEvidenced',
    ServiceCallCompleted = 'ServiceCallCompleted',
}

export const OrderState = {
    Concept: 'Concept',
    SendingToSAP: 'SendingToSAP',
    Accepted: 'Accepted',
    Confirmed: 'Confirmed',
    PartiallyReady: 'PartiallyReady',
    Ready: 'Ready',
    PartiallyExpended: 'PartiallyExpended',
    Dispatched: 'Dispatched',
    Closed: 'Closed',
    Canceled: 'Canceled',
    SendToSapError: 'SendToSapError',
} as const;

export enum OrderLineState {
    NotReady = 'NotReady',
    PartiallyReady = 'PartiallyReady',
    Ready = 'Ready',
    PartiallyExpended = 'PartiallyExpended',
    Dispatched = 'Dispatched',
    Closed = 'Closed',
}

export enum ItemType {
    Simple = 'Simple',
    Configurable = 'Configurable',
    Option = 'Option',
    Assembly = 'Assembly',
}

export enum DemandState {
    Draft = 'Draft',
    Sent = 'Sent',
    Confirmed = 'Confirmed',
    Cancelled = 'Cancelled',
    Ready = 'Ready',
}

export enum ReclamationState {
    Unknown = 'Unknown',
    Accepted = 'Accepted',
    Approved = 'ClaimAccepted',
    Rejected = 'ClaimRejected',
    Goodwill = 'GoodWill',
    ServiceSet = 'ServiceSet',
    Correction = 'Correction',
    DamageEvent = 'DamageEvent',
    PaidService = 'PaidService',
}

export enum InvoiceState {
    Open = 'O',
    Closed = 'C',
}

export enum DeliveryListState {
    Open = 'O',
    Closed = 'C',
}

export enum AddressType {
    B = 'B',
    S = 'S',
}

export enum DashboardType {
    FinishedOrdersYear = 'FinishedOrdersYear',
    InvoicesYear = 'InvoicesYear',
    AllOrdersMonth = 'AllOrdersMonth',
    OpenOrderLinesMonth = 'OpenOrderLinesMonth',
}

export enum FilterOperator {
    Eq = 'eq',
    Neq = 'neq',
    Gt = 'gt',
    Gte = 'gte',
    Lt = 'lt',
    Lte = 'lte',
    Like = 'like',
    Ilike = 'ilike',
    Llike = 'llike',
    Illike = 'illike',
    Rlike = 'rlike',
    Irlike = 'irlike',
    In = 'in',
}

export const isFilterOperator = (op?: string | null): op is FilterOperator => {
    if (op == null) return false;
    return Object.values(FilterOperator).find((x) => x.toString() === op) != null;
};
